<template>
  <app-toast
    class="delete-bank-toast"
    :message="message"
  >
    <div
      class="toast-body"
      v-html="$t('account.delete', { bankName: message.bank.name })"
    />
  </app-toast>
</template>

<script>
  import appToast from '@/components/app-toast'

  export default {
    name: 'DeleteBank',

    components: {
      'app-toast': appToast
    },
    props: {
      message: Object
    }
  }
</script>

<style lang='scss' rel='stylesheet/scss'>
  @import '~@/styles/vars.scss';

  .delete-bank-toast {
    strong {
      color: map_get($palette-primary, main);
    }
  }
</style>
